// extracted by mini-css-extract-plugin
export default {"banner":"WxR7","title":"wIeP9","icons":"LSEVY","phone":"VR97x","qr-code":"zZhac"};